import * as THREE from 'three'
import { Suspense, useRef } from 'react'
import { Canvas, useFrame, useThree } from '@react-three/fiber'
import { Preload, Image as ImageImpl } from '@react-three/drei'
import { ScrollControls, Scroll, useScroll } from './scrollControls'
import img1 from './images/img1.jpg'
import img2 from './images/img2.jpg'
import img3 from './images/img3.jpg'
import img4 from './images/img4.jpg'
import img5 from './images/img5.jpg'
import img6 from './images/img6.jpg'
import img7 from './images/img7.jpg'
import trip1 from './images/trip1.jpg'
import trip2 from './images/trip2.jpg'
import trip3 from './images/trip3.jpg'
import "./peffect.css"
function Image(props) {
  const ref = useRef()
  const group = useRef()
  const data = useScroll()
  useFrame((state, delta) => {
    group.current.position.z = THREE.MathUtils.damp(group.current.position.z, Math.max(0, data.delta * 50), 4, delta)
    ref.current.material.grayscale = THREE.MathUtils.damp(ref.current.material.grayscale, Math.max(0, 1 - data.delta * 1000), 4, delta)
  })
  return (
    <group ref={group}>
      <ImageImpl ref={ref} {...props} />
    </group>
  )
}

function Page({ m = 0.4, urls, ...props }) {
  const { width } = useThree((state) => state.viewport)
  const w = width < 10 ? 1.5 / 3 : 1 / 3
  return (
    <group {...props}>
      <Image position={[-width * w, 0, -1]} scale={[width * w - m * 2, 5, 1]} url={urls[0]} />
      <Image position={[0, 0, 0]} scale={[width * w - m * 2, 5, 1]} url={urls[1]} />
      <Image position={[width * w, 0, 1]} scale={[width * w - m * 2, 5, 1]} url={urls[2]} />
    </group>
  )
}

function Pages() {
  const { width } = useThree((state) => state.viewport)
  return (
    <>
      <Page position={[-width * 1, 0, 0]} urls={[trip1, trip2, trip3]} />
      <Page position={[width * 0, 0, 0]} urls={[img1, img2, img3]} />
      <Page position={[width * 1, 0, 0]} urls={[img4, img5, img6]} />
      <Page position={[width * 2, 0, 0]} urls={[trip1, trip2, trip3]} />
      <Page position={[width * 3, 0, 0]} urls={[img1, img2, img3]} />
      <Page position={[width * 4, 0, 0]} urls={[img4, img5, img6]} />
    </>
  )
}

export default function projectEffect() {
  return (
    <div className='heffe'>
    <Canvas  gl={{ antialias: false }} dpr={[1, 1.5]}>
      <Suspense fallback={null}>
        <ScrollControls infinite horizontal damping={4} pages={4} distance={1}>
          <Scroll >
            <Pages />
          </Scroll>
          <Scroll html>
            <h1 className='heffec'  style={{  left: '0vw'}}>Full</h1>
            <h1 className='heffec' style={{  left: '100vw'}}>Stack</h1>
            <h1 className='heffec' style={{  left: '200vw'}}>web</h1>
            <h1 className='heffec' style={{  left: '300vw'}}>dev</h1>
          </Scroll>
        </ScrollControls>
        <Preload />
      </Suspense>
    </Canvas>
    </div>
  )
}
